import { useEffect, useState } from "react";

// component
import {
  InputText,
  InputTextDate,
  InputTextTel,
  InputTextName,
  InputTextZipCode,
  InputTextSpace,
  InputTextMailAddress,
  InputTextFormTel,
  InputMultiText,
  InputPullDown,
  InputCheckBox,
  InputPicuture,
} from "../component/input";

import {
  InputServicePullDown,
  InputServiceCheckBox,
  InputPaymentCheckBox,
  AgreePdfCheckBox,
} from "../component/otherInput";

import {
  JPaymentSubmitBottom,
  SBPaymentSubmitBottom,
  DummySubmitBottom,
  SubmitBottom,
} from "../component/submitBotton";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

function EntryForm() {
  // 事前取得情報
  const layoutConfig = useAtomValue(AppAtoms.layoutConfig);
  const pdfDatas = useAtomValue(AppAtoms.pdfDatas);
  const paymentMethod = useAtomValue(AppAtoms.paymentMethod);
  const pullDownService = useAtomValue(AppAtoms.pullDownService);
  const checkBoxService = useAtomValue(AppAtoms.checkBoxService);
  const options = useAtomValue(AppAtoms.options);

  // サービス選択データ
  const [selectPullDownPlan, setSelectPullDownPlan] =
    useState<string>("特に選択しない");
  const [selectCheckBoxPlans, setSelectCheckBoxPlans] = useState<string[]>([]);
  // サービス 料金合計
  const [serviceValues, setServiceValues] = useState<number>(0);
  // サービス 税金合計
  const [serviceTaxs, setServiceTaxs] = useState<number>(0);

  useEffect(() => {
    // サービス料金の計算
    let serviceValues = 0;
    let serviceTaxs = 0;
    // プルダウン
    pullDownService.map((plan) => {
      if (selectPullDownPlan === plan.service_name) {
        serviceValues += plan.value;
        serviceTaxs += plan.tax;
      }
    });
    // チェックボックス
    checkBoxService.map((plan) => {
      if (selectCheckBoxPlans.includes(plan.service_name)) {
        serviceValues += plan.value;
        serviceTaxs += plan.tax;
      }
    });
    setServiceValues(serviceValues);
    setServiceTaxs(serviceTaxs);
  }, [selectPullDownPlan, selectCheckBoxPlans]);

  // 支払方法選択
  const [selectPaymentMethod, setSelectPaymentMethod] = useState("");

  // form 入力データ
  const formDataColumns = options.reduce((column, option) => {
    let option_value: string | string[] = "";
    if (option.option_type === 0) {
      option_value = option.option_default_value as string;
      return {
        ...column,
        [option.option_name as string]: option_value,
      };
    } else if (option.option_type === 1 || option.option_type === 4) {
      return {
        ...column,
        [option.option_name as string]: "",
      };
    } else if (option.option_type === 3) {
      return {
        ...column,
        [option.option_name as string]: "2000-01-01",
      };
    } else {
      return {
        ...column,
        [option.option_name as string]: [],
      };
    }
  }, {});
  const [formData, setFormData] = useState<{
    [key: string]: string | string[];
  }>(formDataColumns);
  const [formTel, setFormTel] = useState("");
  const [formEMail, setFormEMail] = useState("");

  // 画像データ保持用
  const [postPictures, setPostPicture] = useState<{
    [key: string]: File;
  }>({});

  const [addressOptionName, setAddressOptionName] = useState("");
  useEffect(() => {
    options.map((option) => {
      if (option.address_flg == 1) {
        setAddressOptionName(option.option_name);
      }
    });
  }, []);

  // pdf 同意
  const [checkPDF, setCheckPDF] = useState<string[]>([]);

  // 事前登録情報
  // 事前登録情報の処理完了後に描写を開始
  const [beforeInputFlg, setBeforeInputFlg] = useState(false);
  const beforeInputCustomerInfo = useAtomValue(
    AppAtoms.beforeInputCustomerInfo
  );
  useEffect(() => {
    if (
      beforeInputCustomerInfo &&
      Object.keys(beforeInputCustomerInfo).length !== 0
    ) {
      // 事前登録情報の反映
      // 顧客情報
      const beforeCustomerInfo = beforeInputCustomerInfo.customer_info as {
        [key: string]: string;
      };
      let _formData = formData;
      options.map((option) => {
        if (option.option_name in beforeCustomerInfo) {
          _formData[option.option_name] =
            beforeCustomerInfo[option.option_name];
          if (option.tel_flg == 1) {
            setFormTel(beforeCustomerInfo[option.option_name]);
          }
          if (option.mail_address_flg == 1) {
            setFormEMail(beforeCustomerInfo[option.option_name]);
          }
        }
      });
      setFormData(_formData);

      // サービス情報
      // プルダウン
      let selectPullDownPlan: string = "";
      const BeforePullDownServiceName =
        beforeInputCustomerInfo.pull_down_service_name as string;
      pullDownService.map((plan) => {
        if (BeforePullDownServiceName === plan.service_name) {
          selectPullDownPlan = plan.service_name;
        }
      });
      setSelectPullDownPlan(selectPullDownPlan);

      // チェックボックス
      let selectCheckBoxPlans: string[] = [];
      const BeforeCheckBoxServiceNameArray = (
        beforeInputCustomerInfo.check_box_service_names as string
      ).split(",");
      checkBoxService.map((plan) => {
        if (BeforeCheckBoxServiceNameArray.includes(plan.service_name)) {
          selectCheckBoxPlans.push(plan.service_name);
        }
      });
      setSelectCheckBoxPlans(selectCheckBoxPlans);

      // 支払方法
      const beforePaymentMethod =
        beforeInputCustomerInfo.payment_method as string;
      paymentMethod.map((paymentMethod) => {
        if (paymentMethod.name === beforePaymentMethod) {
          setSelectPaymentMethod(paymentMethod.type);
        }
      });
    }
    setBeforeInputFlg(true);
  }, [beforeInputCustomerInfo]);

  // 申込ボタンを押せるかどうか trueで押せない
  const [disableFormBottom, setDisableFormBottom] = useState(true);
  useEffect(() => {
    let disableFormBottom = false;

    // サービス - プルダウン
    if (
      pullDownService.length > 0 &&
      layoutConfig.service_option_name_pull_down !== "-" &&
      layoutConfig.service_required_optional_pull_down === "必須" &&
      selectPullDownPlan === "特に選択しない"
    ) {
      disableFormBottom = true;
    }

    // サービス - チェックボックス
    if (
      checkBoxService.length > 0 &&
      layoutConfig.service_option_name_check_box !== "-" &&
      layoutConfig.service_required_optional_check_box === "必須" &&
      selectCheckBoxPlans.length === 0
    ) {
      disableFormBottom = true;
    }

    // サービス - プルダウン、チェックボックスともに選択なし
    if (
      selectPullDownPlan === "特に選択しない" &&
      selectCheckBoxPlans.length === 0
    ) {
      disableFormBottom = true;
    }

    // 入力フォーム
    options.map((option) => {
      const depend_service_names = option.depend_service_names;
      const selectPlans = [selectPullDownPlan, ...selectCheckBoxPlans];
      const depend_option_name = option.depend_option_name;
      const depend_select_names = option.depend_select_names;
      const depend_option_value = formData[depend_option_name];
      if (
        option.required_optional == 1 &&
        (depend_service_names.length === 0 ||
          depend_service_names.some((item) => selectPlans.includes(item))) &&
        (depend_option_name === "他質問に依存しない" ||
          (typeof depend_option_value === "string" &&
            depend_select_names.includes(depend_option_value as string)) ||
          (typeof depend_option_value === "object" &&
            depend_select_names.some((item) =>
              depend_option_value.includes(item)
            )))
      ) {
        if (
          option.option_type === 0 ||
          option.option_type === 1 ||
          option.option_type === 3
        ) {
          const customerInfoValue = formData[option.option_name] as string;
          if (
            customerInfoValue === undefined ||
            customerInfoValue === "" ||
            customerInfoValue === " " ||
            customerInfoValue === "--"
          ) {
            disableFormBottom = true;
          }
        } else if (option.option_type === 2) {
          const customerInfoValue = formData[option.option_name] as string[];
          if (customerInfoValue.length === 0) {
            disableFormBottom = true;
          }
        } else if (option.option_type === 4) {
          if (!postPictures[option.option_name]) {
            disableFormBottom = true;
          }
        }
      }
    });

    // PDF
    pdfDatas.map((pdf) => {
      if (
        pdf.site_pdf_agree === "同意あり" &&
        !checkPDF.includes(pdf.header_location_pdf)
      ) {
        disableFormBottom = true;
      }
    });

    setDisableFormBottom(disableFormBottom);
  }, [
    selectPullDownPlan,
    selectCheckBoxPlans,
    formData,
    checkPDF,
    postPictures,
  ]);
  return beforeInputFlg ? (
    <div className="contact_wrap">
      <h2 id="outline__1">お申し込み</h2>
      <div
        className="wpcf7 js"
        id="wpcf7-f6-o1"
        lang="ja"
        dir="ltr"
        data-wpcf7-id="6"
      >
        <div className="wpcf7-form init">
          {pullDownService.length > 0 &&
          layoutConfig.service_option_name_pull_down !== "-" ? (
            <InputServicePullDown
              plan_label={layoutConfig.service_option_name_pull_down}
              plans={pullDownService}
              selectPullDownPlan={selectPullDownPlan}
              setSelectPullDownPlan={setSelectPullDownPlan}
              service_required_optional_pull_down={
                layoutConfig.service_required_optional_pull_down
              }
              service_trial_period_months={
                layoutConfig.trial_period_months ===
                "特に表示なし（登録月から課金開始）"
                  ? ""
                  : layoutConfig.trial_period_months === "１か月間無料"
                  ? " (最大1ヶ月無料)"
                  : layoutConfig.trial_period_months === "２か月間無料"
                  ? " (最大2ヶ月無料)"
                  : layoutConfig.trial_period_months === "３か月間無料"
                  ? " (最大3ヶ月無料)"
                  : layoutConfig.trial_period_months === "４か月間無料"
                  ? " (最大4ヶ月無料)"
                  : layoutConfig.trial_period_months === "５か月間無料"
                  ? " (最大5ヶ月無料)"
                  : layoutConfig.trial_period_months === "６か月間無料"
                  ? " (最大半年間無料)"
                  : ""
              }
            />
          ) : null}
          {checkBoxService.length > 0 &&
          layoutConfig.service_option_name_check_box !== "-" ? (
            <InputServiceCheckBox
              plan_label={layoutConfig.service_option_name_check_box}
              plans={checkBoxService}
              selectCheckBoxPlans={selectCheckBoxPlans}
              setSelectCheckBoxPlans={setSelectCheckBoxPlans}
              service_required_optional_check_box={
                layoutConfig.service_required_optional_check_box
              }
              service_trial_period_months={
                layoutConfig.trial_period_months ===
                "特に表示なし（登録月から課金開始）"
                  ? ""
                  : layoutConfig.trial_period_months === "１か月間無料"
                  ? " (最大1ヶ月無料)"
                  : layoutConfig.trial_period_months === "２か月間無料"
                  ? " (最大2ヶ月無料)"
                  : layoutConfig.trial_period_months === "３か月間無料"
                  ? " (最大3ヶ月無料)"
                  : layoutConfig.trial_period_months === "４か月間無料"
                  ? " (最大4ヶ月無料)"
                  : layoutConfig.trial_period_months === "５か月間無料"
                  ? " (最大5ヶ月無料)"
                  : layoutConfig.trial_period_months === "６か月間無料"
                  ? " (最大半年間無料)"
                  : ""
              }
            />
          ) : null}
          {options.map((option) => {
            const depend_service_names = option.depend_service_names;
            const selectPlans = [selectPullDownPlan, ...selectCheckBoxPlans];
            const depend_option_name = option.depend_option_name;
            const depend_select_names = option.depend_select_names;
            const depend_option_value = formData[depend_option_name];
            if (
              (depend_service_names.length === 0 ||
                depend_service_names.some((item) =>
                  selectPlans.includes(item)
                )) &&
              (depend_option_name === "他質問に依存しない" ||
                (typeof depend_option_value === "string" &&
                  depend_select_names.includes(
                    depend_option_value as string
                  )) ||
                (typeof depend_option_value === "object" &&
                  depend_select_names.some((item) =>
                    depend_option_value.includes(item)
                  )))
            ) {
              if (option.option_type === 0) {
                if (option.tel_flg === 1) {
                  return (
                    <InputTextTel
                      option={option}
                      formData={formData}
                      setFormData={setFormData}
                      setFormTel={setFormTel}
                      setFormEMail={setFormEMail}
                      addressOptionName={addressOptionName}
                    />
                  );
                } else if (option.name_flg === 1) {
                  return (
                    <InputTextName
                      option={option}
                      formData={formData}
                      setFormData={setFormData}
                      setFormTel={setFormTel}
                      setFormEMail={setFormEMail}
                      addressOptionName={addressOptionName}
                    />
                  );
                } else if (option.company_name_flg === 1) {
                  return (
                    <InputText
                      option={option}
                      formData={formData}
                      setFormData={setFormData}
                      setFormTel={setFormTel}
                      setFormEMail={setFormEMail}
                      addressOptionName={addressOptionName}
                    />
                  );
                } else if (option.zip_code_flg === 1) {
                  return (
                    <InputTextZipCode
                      option={option}
                      formData={formData}
                      setFormData={setFormData}
                      setFormTel={setFormTel}
                      setFormEMail={setFormEMail}
                      addressOptionName={addressOptionName}
                    />
                  );
                } else if (option.space_flg === 1) {
                  return (
                    <InputTextSpace
                      option={option}
                      formData={formData}
                      setFormData={setFormData}
                      setFormTel={setFormTel}
                      setFormEMail={setFormEMail}
                      addressOptionName={addressOptionName}
                    />
                  );
                } else if (option.mail_address_flg === 1) {
                  return (
                    <InputTextMailAddress
                      option={option}
                      formData={formData}
                      setFormData={setFormData}
                      setFormTel={setFormTel}
                      setFormEMail={setFormEMail}
                      addressOptionName={addressOptionName}
                    />
                  );
                } else if (option.form_tel_flg === 1) {
                  return (
                    <InputTextFormTel
                      option={option}
                      formData={formData}
                      setFormData={setFormData}
                      setFormTel={setFormTel}
                      setFormEMail={setFormEMail}
                      addressOptionName={addressOptionName}
                    />
                  );
                } else if (option.multi_text_flg === 1) {
                  return (
                    <InputMultiText
                      option={option}
                      formData={formData}
                      setFormData={setFormData}
                      setFormTel={setFormTel}
                      setFormEMail={setFormEMail}
                      addressOptionName={addressOptionName}
                    />
                  );
                } else if (option.half_width_number_flg === 1) {
                  return (
                    <InputText
                      option={option}
                      formData={formData}
                      setFormData={setFormData}
                      setFormTel={setFormTel}
                      setFormEMail={setFormEMail}
                      addressOptionName={addressOptionName}
                    />
                  );
                } else {
                  return (
                    <InputText
                      option={option}
                      formData={formData}
                      setFormData={setFormData}
                      setFormTel={setFormTel}
                      setFormEMail={setFormEMail}
                      addressOptionName={addressOptionName}
                    />
                  );
                }
              } else if (option.option_type === 1) {
                return (
                  <InputPullDown
                    option={option}
                    formData={formData}
                    setFormData={setFormData}
                    setFormTel={setFormTel}
                    setFormEMail={setFormEMail}
                    addressOptionName={addressOptionName}
                  />
                );
              } else if (option.option_type === 2) {
                return (
                  <InputCheckBox
                    option={option}
                    formData={formData}
                    setFormData={setFormData}
                    setFormTel={setFormTel}
                    setFormEMail={setFormEMail}
                    addressOptionName={addressOptionName}
                  />
                );
              } else if (option.option_type === 3) {
                return (
                  <InputTextDate
                    option={option}
                    formData={formData}
                    setFormData={setFormData}
                    setFormTel={setFormTel}
                    setFormEMail={setFormEMail}
                    addressOptionName={addressOptionName}
                  />
                );
              } else if (option.option_type === 4) {
                return (
                  <InputPicuture
                    option={option}
                    formData={formData}
                    setFormData={setFormData}
                    postPictures={postPictures}
                    setPostPicture={setPostPicture}
                  />
                );
              }
            }
          })}
          {paymentMethod.length > 0 ? (
            <InputPaymentCheckBox
              paymentMethod={paymentMethod}
              selectPaymentMethod={selectPaymentMethod}
              setSelectPaymentMethod={setSelectPaymentMethod}
            />
          ) : null}
          {pdfDatas.map((pdf) => {
            if (pdf.site_pdf_agree === "同意あり") {
              return (
                <AgreePdfCheckBox
                  file_path={pdf.header_location_pdf}
                  file_name={pdf.site_pdf_name}
                  checkPDF={checkPDF}
                  setCheckPDF={setCheckPDF}
                />
              );
            }
          })}
          {paymentMethod.length > 0 ? (
            selectPaymentMethod == "j-payment" ? (
              <JPaymentSubmitBottom
                submit_text={"お申し込みをする"}
                disabled={disableFormBottom}
                selectPullDownPlan={selectPullDownPlan}
                selectCheckBoxPlans={selectCheckBoxPlans}
                formData={formData}
                postPictures={postPictures}
                serviceValues={serviceValues}
                serviceTaxs={serviceTaxs}
                formTel={formTel}
                formEMail={formEMail}
              />
            ) : selectPaymentMethod == "sbpayment-softbank" &&
              layoutConfig.trial_period_months !==
                "特に表示なし（登録月から課金開始）" ? (
              <SBPaymentSubmitBottom
                submit_text={"お申し込みをする"}
                disabled={disableFormBottom}
                selectPullDownPlan={selectPullDownPlan}
                selectCheckBoxPlans={selectCheckBoxPlans}
                formData={formData}
                postPictures={postPictures}
                serviceValues={serviceValues}
                serviceTaxs={serviceTaxs}
                pay_method={"softbank2"}
              />
            ) : selectPaymentMethod == "sbpayment-kddi" &&
              layoutConfig.trial_period_months !==
                "特に表示なし（登録月から課金開始）" ? (
              <SBPaymentSubmitBottom
                submit_text={"お申し込みをする"}
                disabled={disableFormBottom}
                selectPullDownPlan={selectPullDownPlan}
                selectCheckBoxPlans={selectCheckBoxPlans}
                formData={formData}
                postPictures={postPictures}
                serviceValues={serviceValues}
                serviceTaxs={serviceTaxs}
                pay_method={"auone"}
              />
            ) : (
              <DummySubmitBottom submit_text={"お申し込みをする"} />
            )
          ) : (
            <SubmitBottom
              submit_text={"お申し込みをする"}
              disabled={disableFormBottom}
              selectPullDownPlan={selectPullDownPlan}
              selectCheckBoxPlans={selectCheckBoxPlans}
              formData={formData}
              postPictures={postPictures}
              serviceValues={serviceValues}
              serviceTaxs={serviceTaxs}
            />
          )}
        </div>
      </div>
    </div>
  ) : null;
}
export default EntryForm;
